import { marketingApi } from '@/api/MarketingApi'
import Config from '@/config'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

export const useFetchPatientReferral = () => {
	const { data, isLoading, isError } = useQuery({
		queryKey: ['fetch-patient-referral'],
		queryFn: () => marketingApi.fetchPatientReferral(),
	})

	const referralUrl = useMemo(() => {
		if (!data || !data.referralCode) {
			return ''
		}

		return `${Config.JOIN_URL}?code=${data.referralCode}&utm_source=app_referral`
	}, [data])

	const hasRenderableReferral = useMemo(() => {
		return !isLoading && !!referralUrl
	}, [isLoading, referralUrl])

	return {
		referralUrl,
		isLoading,
		isError,
		hasRenderableReferral,
	}
}
